import { AfterContentInit, Component, Input, OnChanges } from '@angular/core'
import { Observable } from 'rxjs'
import { CurrencyAmountType, Fees } from '../../../../../graphql'
import { CurrencyService } from '../../../../injectable/currency-service'

@Component({
    selector: 'app-booking-price',
    templateUrl: 'booking-price.html'
})
export class BookingPriceComponent implements AfterContentInit, OnChanges {
    @Input() fees: Fees
    @Input() extraFees: Fees

    convertedBookingFee$: Observable<CurrencyAmountType>
    convertedExtraBookingFee$: Observable<CurrencyAmountType>

    constructor(
        private _currencyService: CurrencyService
    ) {
    }

    // Public
    ngAfterContentInit() {
        this.setconvertedFees()
    }

    ngOnChanges() {
        // TODO - revisit
        // Converted fees where not updating when @input fees changed.
        // This has fixed it but not sure it is the best way to do it.
        this.setconvertedFees()
    }

    setconvertedFees() {
        if (this?.fees?.bookingFee) {
            this.convertedBookingFee$ = this._currencyService.convertToPresentmentCurrency(this.fees.bookingFee)
        }
        if (this?.extraFees?.bookingFee) {
            this.convertedExtraBookingFee$ = this._currencyService.convertToPresentmentCurrency(this.extraFees.bookingFee)
        }
    }

    calculateFees(bookingFee: CurrencyAmountType, extraBookingFee?: CurrencyAmountType): number {
        if (!bookingFee) { return }
        if (extraBookingFee) {
            return (bookingFee?.amountMicros + extraBookingFee.amountMicros) / 1000000
        }
        return bookingFee.amountMicros / 1000000
    }
}
